/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown>, total: NonNullable<unknown> }} Coach_Context_WeekInputs */

const en_us2_coach_context_week = /** @type {(inputs: Coach_Context_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week} of ${i?.total}`)
};

const pt_br2_coach_context_week = /** @type {(inputs: Coach_Context_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.total}`)
};

const es_419_coach_context_week = /** @type {(inputs: Coach_Context_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.total}`)
};

const pt_pt2_coach_context_week = /** @type {(inputs: Coach_Context_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.total}`)
};

const fr_fr2_coach_context_week = /** @type {(inputs: Coach_Context_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week} sur ${i?.total}`)
};

const de_de2_coach_context_week = /** @type {(inputs: Coach_Context_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ${i?.week} von ${i?.total}`)
};

const it_it2_coach_context_week = /** @type {(inputs: Coach_Context_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settimana ${i?.week} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Week {week} of {total}" |
*
* @param {Coach_Context_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_context_week = /** @type {((inputs: Coach_Context_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Context_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_context_week(inputs)
	if (locale === "es-419") return es_419_coach_context_week(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_context_week(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_context_week(inputs)
	if (locale === "de-DE") return de_de2_coach_context_week(inputs)
	if (locale === "it-IT") return it_it2_coach_context_week(inputs)
	return en_us2_coach_context_week(inputs)
});
export { coach_context_week as "coach.context_week" }